var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMail48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Mail48*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Envelope",
    transform: "translate(3.000000, 11.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0.75,
    y: 0.75,
    width: 40.5,
    height: 24.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5027927,0.252792747 L41.5442671,0.294267124 L41.2921748,0.75 L41.25,0.75 L41.25,0.41137513 L41.5027927,0.252792747 Z M40.7102054,0.75 L1.28979458,0.75 L21,13.1146402 L40.7102054,0.75 Z M0.75,0.75 L0.707825193,0.75 L0.455732876,0.294267124 L0.497207253,0.252792747 L0.75,0.41137513 L0.75,0.75 Z",
    id: "Focus",
    fill: "#FFCC00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMail48);
export default __webpack_public_path__ + "static/media/pictogramMail48.f2a53f2ca111cf45442b6243077ec265.svg";
export { ForwardRef as ReactComponent };